// extracted by mini-css-extract-plugin
export default {"titleContainer":"ListNewsPage_titleContainer__DtJ+b","newsContainer":"ListNewsPage_newsContainer__qTs6V"};